import { discountRuleSchema } from "@redotech/redo-model/discount-rules/discount-rule";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getDiscountRule = {
  name: "getDiscountRule" as const,
  input: z.object({ ruleId: zExt.objectId() }),
  output: discountRuleSchema,
};
